import { render, staticRenderFns } from "./add-multi-channel-order.vue?vue&type=template&id=7ed26bd8&scoped=true&"
import script from "./add-multi-channel-order.vue?vue&type=script&lang=js&"
export * from "./add-multi-channel-order.vue?vue&type=script&lang=js&"
import style0 from "./add-multi-channel-order.vue?vue&type=style&index=0&id=7ed26bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed26bd8",
  null
  
)

export default component.exports